module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-6-buyback_0011e97e359e6060bbf92772bd227d4e.png";